/**
Copyright (C) 2022 by SeQuenX  - All Rights Reserved
This file is part of the ComplyVantage product development,
and is released under the "Commercial License Agreement".
You should have received a copy of the Commercial License Agreement license with
this file. If not, please write to: legal@sequenx.com, or visit www.sequenx.com
*/
import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import TextSlider from "./TextSlider";
import ImageCarousel from "./ImageCarousel";
import CompanyUpdatesCard from "./CompanyUpdatesCard";
import {
  EcommerceWebsiteDesignHero,
  OSSComplianceSecurityHero,
  SoftwareConsultancyAndTrainingHero,
  SoftwareQualityAndAssuranceHero,
  SoftwareDevelopmentHero,
  DigitalMarketingHero,
  RemoteTeamsHero,
} from "../assets/images";

const HeroSection = () => {
  const { t } = useTranslation();
  const textItems = t("heroSection.textItems", { returnObjects: true });

  // Array of images for the carousel
  const carouselImages = [
    SoftwareDevelopmentHero,
    SoftwareQualityAndAssuranceHero,
    OSSComplianceSecurityHero,
    SoftwareConsultancyAndTrainingHero,
    DigitalMarketingHero,
    EcommerceWebsiteDesignHero,
    RemoteTeamsHero,
  ];

  return (
    <div className="relative bg-white">
      <div className="container mx-auto px-4 py-20 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left content */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-8"
          >
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight">
              <span className="flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-[#22D3EE] mb-10">
                <span className="block w-6 h-0.5 bg-cyan-400"></span>
                {t("heroSection.welcome")}
              </span>
              <span className="block text-gray-900">
                {t("heroSection.tagLineFirst")}
              </span>
              <span
                className="block"
                style={{
                  background:
                    "linear-gradient(90deg, #2DD4BF 0%, #818CF8 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  paddingBottom: "0.1em",
                }}
              >
                {t("heroSection.tagLineSecond")}
              </span>
            </h1>
            <p className="text-lg text-gray-600 leading-relaxed">
              {t("heroSection.subTagLine")}
            </p>

            <div className="bg-gray-50 p-6 rounded-lg border border-gray-100 shadow-sm">
              <TextSlider items={textItems} interval={5000} />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <CompanyUpdatesCard />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
